// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"83d97143c9fb092595ad","655":"03e46710b1352384837b"}[chunkId] + ".js";
};